import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useParams, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Typography, IconButton } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import { Loader } from 'sputnik-ui'
import { useTranslation } from 'react-i18next'

import { fetchCamera } from 'features/Cameras/camerasSlice'
import CameraPlayer from './CameraPlayer'
import CameraInfo from './CameraInfo'

const PageWrapper = styled.div`
  padding: 32px 40px;
  min-height: 100vh;
  width: 100%;
`

const BackRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`

const BackButton = styled(IconButton)`
  && {
    background: #ffffff;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);

    &:hover {
      background: #f2f4f6;
    }
  }
`

const PageTitle = styled(Typography)`
  && {
    font-family: 'Inter', 'Open Sans', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #051125;
  }
`

const AddressSubtitle = styled(Typography)`
  && {
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    color: #8f9bb3;
    margin-left: 4px;
  }
`

function CameraPage() {
  const { uuid } = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation(['cameras_view'])

  const camera = useSelector(({ camerasNew }) => camerasNew.current)
  const pending = useSelector(({ camerasNew }) => camerasNew.pending)

  useEffect(() => {
    if (uuid) {
      dispatch(fetchCamera(uuid))
    }
  }, [dispatch, uuid])

  const handleBack = () => {
    history.push('/cameras')
  }

  if (pending || !camera) {
    return (
      <PageWrapper>
        <BackRow>
          <BackButton size="small" onClick={handleBack}>
            <ArrowBack />
          </BackButton>
          <PageTitle>{t('cameras_view:title')}</PageTitle>
        </BackRow>
        <Loader
          fullPage
          style={{ justifyContent: 'center', display: 'flex' }}
        />
      </PageWrapper>
    )
  }

  const name = camera.alias || camera.serial_number || camera.uuid
  const addr = camera.short_address || camera.address

  return (
    <PageWrapper>
      <BackRow>
        <BackButton size="small" onClick={handleBack}>
          <ArrowBack />
        </BackButton>
        <div>
          <PageTitle>{addr || name}</PageTitle>
          {addr && <AddressSubtitle>{name}</AddressSubtitle>}
        </div>
      </BackRow>

      <CameraPlayer key={uuid} embed={camera.embed} />
      <CameraInfo camera={camera} />
    </PageWrapper>
  )
}

export default CameraPage
